import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class VideosService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }
    /**
     * getLastVideos() - Buscar últimos 3 videos
     *
     */
    getLastVideos(): Observable<any> {
        // Instacia o body através de BaseService.setBody();
        let body = this.setBody();

        // limit: Definir o retorno máximo de vídeos
        body.set('limit', '36');

        let response = this.http
            .post(this.urlService + this.routeAdress.route_news_videos, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }
    getFilterVideos(filters): Observable<any> {
        // Instacia o body através de BaseService.setBody();
        let body = this.setBody();

        if (filters) {
            Object.keys(filters).forEach((filter) => {
                if (filters[filter] !== null && filters[filter] !== '') {
                    if (filters[filter] instanceof Array) {
                        body.set(filter, `[${filters[filter].join(',')}]`);
                    } else {
                        body.set(filter, filters[filter]);
                    }
                }
            });
        }

        // limit: Definir o retorno máximo de vídeos
        body.set('limit', '36');

        let response = this.http
            .post(this.urlService + this.routeAdress.route_news_filter_videos, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }
}
